import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef, inject } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs';
import { Alert, AlertType } from './alert-model';
import { AlertService } from './alert.service';
import { AppModule } from '../../../app-module';

@Component({ selector: 'oaj-alert-itx', templateUrl: 'alert.component.html', imports: [AppModule] })
export class AlertComponent implements OnInit, OnDestroy {
  @Input() id = 'default-alert';
  @Input() fade = true;

  alerts: Alert[] = [];
  alertSubscription: Subscription = new Subscription;
  routeSubscription: Subscription = new Subscription;

  private router: Router = inject(Router);
  private changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  private alertService: AlertService = inject(AlertService);

  /**
   * Se suscribe a los eventos de alerta del servicio de alertas utilizando el ID proporcionado, cada vez que se recibe una alerta se verifica si el mensaje de la alerta está vacío, si es así se filtran las alertas para mantener solo aquellas que deben mantenerse después del cambio de ruta, si el mensaje no está vacío se agrega la alerta a la lista de alertas y si la opción de auto cierre está habilitada, se programa la eliminación automática de la alerta después de un tiempo determinado, también se suscribe a los eventos de navegación del router para limpiar las alertas cuando se inicia una nueva navegación, se limpia la suscripción a los eventos de alerta y navegación cuando el componente se destruye para evitar fugas de memoria
   * @returns 
   */
  ngOnInit() {
    this.alertSubscription = this.alertService.onAlert(this.id)
      .subscribe(alert => {
        if (!alert.message) {
          this.alerts = this.alerts.filter(x => x.keepAfterRouteChange);
          this.alerts.forEach(x => x.keepAfterRouteChange = false);
          return;
        }
        this.alerts.push(alert);
        if (alert.autoClose) {
          setTimeout(() => this.removeAlert(alert), 5000);
        }
      });
    this.routeSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.alertService.clear(this.id);
      }
    });
  }

  /**
   *  Se limpia la suscripción a los eventos de alerta y navegación cuando el componente se destruye para evitar fugas de memoria
   * @returns 
   */
  ngOnDestroy() {
    this.alertSubscription.unsubscribe();
    this.routeSubscription.unsubscribe();
  }

  /**
   * Elimina una alerta de la lista de alertas, se verifica si la alerta existe en la lista, si se encuentra y la opción de fade está habilitada, se marca la alerta para que se desvanezca y después de un tiempo se elimina de la lista, si la opción de fade no está habilitada, se elimina directamente de la lista, después de eliminar la alerta se detectan los cambios para actualizar la vista
   * @param alert 
   * @returns 
   */
  removeAlert(alert: Alert) {

    if (!this.alerts.includes(alert)) return;
    if (this.fade) {

      const foundAlert = this.alerts.find(x => x === alert);
      if (foundAlert) {
        foundAlert.fade = true;
      }

      setTimeout(() => {
        this.alerts = this.alerts.filter(x => x !== alert);
        this.changeDetectorRef.detectChanges();
      }, 250);
    } else {
      this.alerts = this.alerts.filter(x => x !== alert);
      this.changeDetectorRef.detectChanges();
    }
  }

  /**
   * Obtiene las clases CSS para una alerta específica, se verifica si la alerta existe, si se encuentra se devuelven las clases correspondientes al tipo de alerta y al estado de fade
   * @param alert 
   * @returns 
   */
  cssClass(alert: Alert) {
    if (!alert) return;
    const classes = ['alert', 'alert-dismissable'];
    const alertTypeClass = {
      [AlertType.Success]: 'alert alert-success',
      [AlertType.Error]: 'alert alert-danger',
      [AlertType.Info]: 'alert alert-info',
      [AlertType.Warning]: 'alert alert-warning'
    }
    classes.push(alertTypeClass[alert.type]);
    if (alert.fade) {
      classes.push('fade');
    }
    return classes.join(' ');
  }
}
